import { Pipe, PipeTransform } from '@angular/core'
import { ProductCategory } from '@mmx/shared'
import { find } from 'lodash'

@Pipe({
  name: 'backgroundPC',
  standalone: false,
})
export class BackgroundPCPipe implements PipeTransform {
  transform(categoryId: string, productCategories: ProductCategory[]) {
    const productCategory = find(productCategories, (category) => {
      return category.id === categoryId
    })

    if (productCategory) {
      return { 'background': productCategory.color }
    }
  }
}
